module.exports = __webpack_public_path__ + "img/pexels-simon-migaj-1571783.3f39d9fe.jpeg";